// extracted by mini-css-extract-plugin
export var chip = "_bt-0";
export var filterDropdown = "_bt-5";
export var filterItem = "_bt-6";
export var icon = "_bt-1";
export var removeButton = "_bt-3";
export var removeIcon = "_bt-4";
export var separator = "_bt-2";